<template>
	<div class="card">
		<div class="card-header" v-html="Translate('@_GRADUATE_THESIS_LIST')"></div>
		<div class="card-body">
			<theses-table></theses-table>
		</div>
		<div class="card-footer" v-if="result !== null">
			<router-link class="btn btn-primary" v-bind:to="{ name: 'thesis_new' }" v-html="Translate('@_CREATE')" v-if="isProfessor || isAdmin"></router-link>
		</div>
	</div>
</template>

<script>
import Mixin from "@/helpers/mixin";
import ThesesTable from "@/components/ThesesTable";

export default {
	name: "Theses",
	mixins: [Mixin],
	components: { ThesesTable }
};
</script>

<style scoped>
</style>
